import { chakra, Divider, Text, Box, Flex } from "@chakra-ui/react"
import { colours, shadows } from "@shared/ui.design-system"
import { color } from "lib/theme/theme.css"
import { space } from "theme/themeConfig"

export const Separator = chakra(Divider, {
  baseStyle: {
    opacity: 0.2,
    borderColor: "black",
    mt: `${space["1"]} !important`,
  },
})

export const SizeText = chakra(Text, {
  baseStyle: {
    order: { base: 2, md: "unset" },
    variant: "acuminLight",
    mt: { base: 0, md: 1 },
    borderRight: `1px solid ${colours.secondary.deep}`,
    pr: { base: -3, md: -4 },
    mr: { base: -3, md: -4 },
  },
})

export const SuitableForText = chakra(Text, {
  baseStyle: {
    order: { base: 1, md: "unset" },
    flex: { base: "1 0 100%", md: "unset" },
    mt: 1,
    mb: { base: 1, md: 0 },
  },
})

export const CompareToContainer = chakra(Box, {
  baseStyle: {
    w: "100%",
    borderLeft: `4px solid ${color.backgroundAccentStrong}`,
    boxShadow: shadows.bottom.l1,
    px: 1,
    py: "-1",
    mt: 1,
  },
})

export const FlexContainer = chakra(Flex, {
  baseStyle: {
    justifyContent: "space-between",
    alignItems: "center",
  },
})
